import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { DrawerModule } from 'primeng/drawer';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { KeyFilterModule } from 'primeng/keyfilter';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { PopoverModule } from 'primeng/popover';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';

import { UiModule } from '@ui';

import * as COMPONENTS from './components';
import * as DIRECTIVES from './directives';
import * as PIPES from './pipes';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CustomDynamicDialogService } from './services/custom-dialog.service';

@NgModule({
  imports: [
    AccordionModule,
    AutoCompleteModule,
    ButtonModule,
    DatePickerModule,
    CheckboxModule,
    ColorPickerModule,
    CommonModule,
    ConfirmDialogModule,
    DialogModule,
    DrawerModule,
    DragDropModule,
    EditorModule,
    SelectModule,
    FileUploadModule,
    FormsModule,
    InputGroupModule,
    InputGroupAddonModule,
    InputMaskModule,
    InputNumberModule,
    InputTextModule,
    TextareaModule,
    KeyFilterModule,
    MenuModule,
    MessageModule,
    MultiSelectModule,
    PanelModule,
    PopoverModule,
    PanelModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    RadioButtonModule,
    ReactiveFormsModule,
    SelectButtonModule,
    TableModule,
    ToastModule,
    TooltipModule,
    UiModule,
    COMPONENTS.ActiveUserInitialsComponent,
    COMPONENTS.AddEditEmploymentIncomeComponent,
    COMPONENTS.AusStatusChipComponent,
    COMPONENTS.FileOutdatedModalComponent,
    COMPONENTS.MultipleEditorsModalComponent,
    COMPONENTS.BorrowerAddressChildComponent,
    COMPONENTS.BorrowerAddressMainComponent,
    COMPONENTS.BorrowerDetailsMainComponent,
    COMPONENTS.BorrowerPropertyInformationComponent,
    COMPONENTS.CmgFormArrayRadioButtonComponent,
    COMPONENTS.CmgFormControlZipCodeComponent,
    COMPONENTS.CmgValidatorMessagesComponent,
    COMPONENTS.ContentAreaScrollableComponent,
    COMPONENTS.CreditInfoComponent,
    COMPONENTS.EmploymentIncomeExpensesComponent,
    COMPONENTS.ErrorNavComponent,
    COMPONENTS.FicoScoreComponent,
    COMPONENTS.HousingExpensesComponent,
    COMPONENTS.InfoPanelContentComponent,
    COMPONENTS.InfoRowComponent,
    COMPONENTS.LiabilitiesComponent,
    COMPONENTS.LiabilityDetailsComponent,
    COMPONENTS.LoanMortgageTypeComponent,
    COMPONENTS.LoanPartyDetailsComponent,
    COMPONENTS.MiQuoteComponent,
    COMPONENTS.MiQuoteResultComponent,
    COMPONENTS.MortgageInformationComponent,
    COMPONENTS.NavbarComponent,
    COMPONENTS.NotesPanelComponent,
    COMPONENTS.NotesPanelV2Component,
    COMPONENTS.SellerContractContactInformationComponent,
    COMPONENTS.SlideOutPanelComponent,
    COMPONENTS.SubjectPropertyInformationComponent,
    COMPONENTS.UnderwritingInformationComponent,
    COMPONENTS.RowComponent,
    DIRECTIVES.CmgFocusSelectDirective,
    DIRECTIVES.CmgFormControlDomDirective,
    DIRECTIVES.CmgFormControlFactorResetDirective,
    DIRECTIVES.CmgInViewDirective,
    DIRECTIVES.CmgInputErrorDirective,
    DIRECTIVES.CmgInputRemoveSpacesDirective,
    DIRECTIVES.CmgInputTrimSpacesDirective,
    DIRECTIVES.CmgPrimeNgCalendarFocusDirective,
    DIRECTIVES.CmgPrimeNgDatePickerMaskDirective,
    DIRECTIVES.CmgPrimeNgDropdownBlurDirective,
    DIRECTIVES.CmgPrimeNgInputMaskFocusDirective,
    DIRECTIVES.CmgPrimeNgInputNumberFocusDirective,
    DIRECTIVES.CmgPrimeNgSsnMaskDirective,
    PIPES.AbsoluteValuePipe,
    PIPES.WholeNumberPipe,
    PIPES.CamelCaseToStringPipe,
    PIPES.EmptyToDashPipe,
    PIPES.FormatSocialSecurityPipe,
    PIPES.FormatZipcodePipe,
    PIPES.FromNowPipe,
    PIPES.HideSsnPipe,
    PIPES.NegativeCurrencyToParenthesisPipe,
    PIPES.OrderByPipe,
    PIPES.PhoneNumberPipe,
    PIPES.QaSlugPipe,
    PIPES.ReplaceTextPipe,
    PIPES.SafeHtmlPipe,
    PIPES.SplitTitleCasePipe,
    PIPES.ToBorrowerNamePipe,
    PIPES.ToEnumPipe,
    PIPES.ToNameOrValueNoSelectPipe,
    PIPES.ToNameOrValuePipe,
    PIPES.ToSentencePipe,
    PIPES.YesNoPipe,
    PIPES.GetListLabelByValuePipe,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    COMPONENTS.ActiveUserInitialsComponent,
    COMPONENTS.AusStatusChipComponent,
    COMPONENTS.BorrowerAddressMainComponent,
    COMPONENTS.BorrowerDetailsMainComponent,
    COMPONENTS.BorrowerPropertyInformationComponent,
    COMPONENTS.CmgFormArrayRadioButtonComponent,
    COMPONENTS.CmgFormControlZipCodeComponent,
    COMPONENTS.CmgValidatorMessagesComponent,
    COMPONENTS.ContentAreaScrollableComponent,
    COMPONENTS.CreditInfoComponent,
    COMPONENTS.EmploymentIncomeExpensesComponent,
    COMPONENTS.ErrorNavComponent,
    COMPONENTS.FicoScoreComponent,
    COMPONENTS.HousingExpensesComponent,
    COMPONENTS.LiabilitiesComponent,
    COMPONENTS.LiabilityDetailsComponent,
    COMPONENTS.LoanMortgageTypeComponent,
    COMPONENTS.LoanPartyDetailsComponent,
    COMPONENTS.MiQuoteComponent,
    COMPONENTS.MortgageInformationComponent,
    COMPONENTS.NavbarComponent,
    COMPONENTS.NotesPanelComponent,
    COMPONENTS.NotesPanelV2Component,
    COMPONENTS.SellerContractContactInformationComponent,
    COMPONENTS.SlideOutPanelComponent,
    COMPONENTS.SubjectPropertyInformationComponent,
    COMPONENTS.UnderwritingInformationComponent,
    COMPONENTS.RowComponent,
    COMPONENTS.InfoPanelContentComponent,
    COMPONENTS.InfoRowComponent,
    DIRECTIVES.CmgFocusSelectDirective,
    DIRECTIVES.CmgFormControlDomDirective,
    DIRECTIVES.CmgFormControlFactorResetDirective,
    DIRECTIVES.CmgInViewDirective,
    DIRECTIVES.CmgInputErrorDirective,
    DIRECTIVES.CmgInputRemoveSpacesDirective,
    DIRECTIVES.CmgInputTrimSpacesDirective,
    DIRECTIVES.CmgPrimeNgCalendarFocusDirective,
    DIRECTIVES.CmgPrimeNgDatePickerMaskDirective,
    DIRECTIVES.CmgPrimeNgDropdownBlurDirective,
    DIRECTIVES.CmgPrimeNgInputMaskFocusDirective,
    DIRECTIVES.CmgPrimeNgInputNumberFocusDirective,
    DIRECTIVES.CmgPrimeNgSsnMaskDirective,
    PIPES.AbsoluteValuePipe,
    PIPES.WholeNumberPipe,
    PIPES.CamelCaseToStringPipe,
    PIPES.EmptyToDashPipe,
    PIPES.FormatSocialSecurityPipe,
    PIPES.FormatZipcodePipe,
    PIPES.FromNowPipe,
    PIPES.HideSsnPipe,
    PIPES.NegativeCurrencyToParenthesisPipe,
    PIPES.OrderByPipe,
    PIPES.PhoneNumberPipe,
    PIPES.QaSlugPipe,
    PIPES.ReplaceTextPipe,
    PIPES.SafeHtmlPipe,
    PIPES.SplitTitleCasePipe,
    PIPES.ToBorrowerNamePipe,
    PIPES.ToEnumPipe,
    PIPES.ToNameOrValueNoSelectPipe,
    PIPES.ToNameOrValuePipe,
    PIPES.ToSentencePipe,
    PIPES.YesNoPipe,
    PIPES.GetListLabelByValuePipe,
  ],
  providers: [
    Document,
    ConfirmationService,
    {
      provide: DialogService,
      useClass: CustomDynamicDialogService,
    },
    MessageService,
  ],
})
export class CmgSharedModule {}
